const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

const nodeEnv = import.meta.env.MODE;
const redirectUri:string = import.meta.env.VITE_REDIRECT_URL ?? "http://localhost:3000/"
const authority:string = import.meta.env.VITE_AUTH_ENV_AUTHORITY ?? ""
const clientId:string = import.meta.env.VITE_AUTH_ENV_CLIENTID ?? ""

let authEnv;
if (!nodeEnv || nodeEnv === "development") {
  console.log("development build code"); // development build code
  authEnv = {
    authority: authority,
    clientId: clientId,
    redirectUri: redirectUri,
  };
} else {
  console.log("production build code"); // production build code
  authEnv = {
    authority: authority,
    clientId: clientId,
    redirectUri: redirectUri,
    postLogoutRedirectUri: "/",
  };
}

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: authEnv,
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};
